import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { CreateStaticSitePage } from '@/routes/static-sites/create-static-site/page'

export const CreateStaticSite = () => {
  return (
    <PageErrorBoundary>
      <CreateStaticSitePage />
    </PageErrorBoundary>
  )
}
